import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Right from './Right';
import Left from './Left';
import appRoutes from '../../../../appRoutes';
import TopBarLayout from '../../Common/TopBarLayout';

const TopBar = () => {
  return <TopBarLayout Left={<Left />} Right={<Right />} />;
};

const Gate = () => (
  <Routes>
    <Route path={appRoutes.loggedIn.showWallBoard} element={null} />
    <Route path={'*'} element={<TopBar />} />
  </Routes>
);

export default Gate;
